'use client';

import NewsLetter from '@/app/(portal)/(policy)/policy/policy-details/[policyNo]/sections/newsletter/newsletter';
import React from 'react';

const NewsletterWrapper = () => {
  return <NewsLetter.dashboard />;
};

export default NewsletterWrapper;
